export { AssicurazioneGenerali } from './AssicurazioneGenerali';
export type { AssicurazioneGeneraliProps } from './AssicurazioneGenerali';
